import React, { useState } from 'react';
import './SchoolsGridContainer.scss';
import FileUploadModal from 'components/modals/FileUploadModal/FileUploadModal';
import SchoolsGridTable from './SchoolsGridTable/SchoolsGridTable';

const SchoolsGridContainer = () => {
  const [isUploadModalVisible, setIsUploadModalVisible] = useState(false);

  return (
    <div className="school-grid-container">
      <SchoolsGridTable
        onFileUploadClickHandler={() => setIsUploadModalVisible(true)}
      />
      {isUploadModalVisible && (
        <FileUploadModal hide={() => setIsUploadModalVisible(false)} />
      )}
    </div>
  );
};

export default SchoolsGridContainer;
